import { createClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase para acessar dados de chamadas
 * Documentação: https://supabase.com/docs/reference/javascript
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://ikhbnvlvpcsxowrdbmew.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlraGJudmx2cGNzeG93cmRibWV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxNTM3MDEsImV4cCI6MjA3MDcyOTcwMX0.-NfjVBQyJcPWnAuj67xLg1IbWUihD5GosTyIxYGQ5FQ';

// ⚠️ TEMPORÁRIO: Usando service_role key para teste (remover depois de corrigir permissões)
const SUPABASE_SERVICE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlraGJudmx2cGNzeG93cmRibWV3Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NTE1MzcwMSwiZXhwIjoyMDcwNzI5NzAxfQ.VCrb0lYjbLq-kjcKGbt1TwOpYKDi8hOZY283Ih6v7dw';

export const supabase = createClient(SUPABASE_URL, SUPABASE_SERVICE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
});

/**
 * Nome da tabela de chamadas no Supabase
 */
export const CALL_RECORDS_TABLE = 'call_recordings';

export default supabase;
